/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { FC, useContext } from 'react'

import {
  useCurrentUser,
  useOrganization,
  useRouter,
  routes,
} from '@builddocs/data-management'
import { AbilityContext } from '@builddocs/data-management-casl'
import { GridPairs } from '@builddocs/mui'
import { Card, CardActions, CardContent, CardHeader, Grid } from '@mui/material'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import { Helmet } from 'react-helmet'

import { titleShort } from '../../../constants/general'

import { AvatarBlock } from './AvatarBlock'
import { GeneralUserInfo } from './GeneralUserInfo'

const AccountScreen: FC = () => {
  const { user } = useCurrentUser()
  const { organization, isLoading } = useOrganization()

  const ability = useContext(AbilityContext)
  const { navigate } = useRouter()

  if (!user) return null

  return (
    <Container disableGutters maxWidth={false} sx={{ p: 4 }}>
      <Helmet>
        <title>{`${user.firstName ?? ''} ${
          user.lastName ?? ''
        } | ${titleShort}`}</title>
      </Helmet>
      <Grid
        container
        alignItems="flex-start"
        mt={1}
        spacing={2}
        sx={{
          display: 'grid',
          gridTemplateColumns: 'auto 1fr',
          justifyContent: { xs: 'flex-start', sm: 'center' },
        }}
      >
        <Grid item gridRow="1/3">
          <AvatarBlock user={user} />
        </Grid>
        <Grid item>
          <GeneralUserInfo
            loading={isLoading}
            organization={organization}
            user={user}
            onClickEdit={() => navigate(routes.account.edit())}
          />
        </Grid>
        <Grid item>
          {ability.can('view', 'EmploymentInfo') ? (
            <Card>
              <CardHeader title="Работаю" />
              <CardContent>
                <GridPairs
                  content={[
                    ['Должность', user?.employment?.position?.description],
                    ['Компания', organization?.name ?? ''],
                    [
                      'Город',
                      organization?.physicalAddress?.city ||
                        organization?.legalAddress?.city,
                    ],
                  ]}
                />
              </CardContent>
              {ability.can('edit', 'Organization') && (
                <CardActions>
                  <Button
                    size="small"
                    onClick={() => navigate(routes.organization.base())}
                  >
                    Управление организацией
                  </Button>
                </CardActions>
              )}
            </Card>
          ) : null}

          {/* <PoaBlock /> */}
        </Grid>
      </Grid>
    </Container>
  )
}

export default AccountScreen
